import script from "./IDEWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDEWindow.vue?vue&type=script&lang=ts&setup=true"

import "./IDEWindow.vue?vue&type=style&index=0&id=5753aee2&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5753aee2"]])

export default __exports__